// GENERATED FILE — do not edit by hand.
// Produced by scripts/generate-api-reference.js from payouts.api.external.yaml.
// Regenerate with `npm run generate:reference` after pulling a new spec, then commit the diff.

// Deliberately untyped (matches how the rest of the reference already treats GROUPS — see the
// (g: any) casts in guides.tsx/home.tsx/reference.tsx): endpoint shapes vary per-operation, and
// this data is generated + regenerated on every build rather than hand-maintained against a type.
export const GENERATED_GROUPS: any[] = [
  {
    "id": "entities",
    "label": "Entities",
    "kind": "resource",
    "endpoints": [
      {
        "id": "get-entities",
        "method": "GET",
        "path": "/v2/entities",
        "name": "List entities",
        "auth": "Partner key",
        "summary": "Returns your entities, newest first. Use the filters below to narrow the list.",
        "queryParams": [
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Return only the entity whose `externalId` matches (your own id)."
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Filter by metadata key/value pairs, e.g. `metadata[crmId]=C-1`. Matches entities whose metadata contains every supplied pair.\n"
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/entities",
          "resource": "entities",
          "action": "list",
          "args": []
        },
        "response": {
          "data": [
            {
              "id": "ent_7c9e6679-7425-40de-944b-e07fc1f90ae7",
              "type": "business",
              "externalId": "partner-biz-1234",
              "createdAt": "2026-07-08T15:00:00Z",
              "updatedAt": "2026-07-08T15:00:00Z",
              "name": "Acme Supplies",
              "legalName": "Acme Supplies LLC",
              "businessType": "llc",
              "taxInfo": {
                "type": "ein",
                "identifierLast4": "6789"
              },
              "phoneNumber": "+12125551234",
              "contact": {
                "firstName": "Jane",
                "lastName": "Doe"
              },
              "website": "https://acmesupplies.com",
              "address": {
                "line1": "350 5th Ave",
                "city": "New York",
                "state": "NY",
                "postalCode": "10118",
                "countryCode": "US"
              },
              "legalAddress": {
                "line1": "350 5th Ave",
                "city": "New York",
                "state": "NY",
                "postalCode": "10118",
                "countryCode": "US"
              },
              "industry": {
                "naicsCode": "424410"
              },
              "owner": {
                "firstName": "Jane",
                "lastName": "Doe",
                "email": "jane.doe@acmesupplies.com"
              }
            }
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "post-entities",
        "method": "POST",
        "path": "/v2/entities",
        "name": "Create an entity",
        "auth": "Partner key",
        "summary": "Creates an entity (a business). A direct partner manages a single entity; a platform partner can create as many as it needs.\n",
        "headerParams": [
          {
            "name": "Idempotency-Key",
            "type": "string",
            "required": false,
            "desc": "Unique key (UUID recommended) that makes a create request safe to retry by replaying the original response; retained 24h per partner.\n"
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed MelioSonar session token from the initiating device, used for risk evaluation; invalid or expired tokens return 403.\n"
          }
        ],
        "fields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "business"
            ],
            "required": true,
            "desc": "Entity type discriminator. Only `business` is supported today."
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Partner's own id for the entity (unique per partner)"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "name",
            "type": "string",
            "required": true,
            "desc": "Company (doing-business-as) name. Between 3 and 100 characters."
          },
          {
            "name": "legalName",
            "type": "string",
            "required": true,
            "desc": "Full legal business name as it appears on the tax return. Between 3 and 100 characters."
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": true,
            "desc": "Business phone number. Must contain at least 9 digits."
          },
          {
            "name": "businessType",
            "type": "enum",
            "options": [
              "partnership",
              "sole-proprietorship",
              "llc",
              "corporation",
              "trust",
              "non-profit",
              "municipality"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "taxInfo.type",
            "type": "enum",
            "options": [
              "ein",
              "ssn",
              "itin"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "taxInfo.identifier",
            "type": "string",
            "required": true,
            "desc": "9-digit tax identifier, optionally dash-separated (e.g. 12-3456789)."
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": true,
            "desc": "Street address. Must not be a PO box for the business (physical) address.\n"
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": true,
            "desc": "Two-letter US state or territory code (e.g. NY, CA). Must be a recognized USPS abbreviation."
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": true,
            "desc": "US ZIP code, 5 or 9 digits, with or without a hyphen before the last 4 (e.g. 10118, 10118-1234)."
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "enum",
            "options": [
              "US"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line1",
            "type": "string",
            "required": true,
            "desc": "Street address. Must not be a PO box for the business (physical) address.\n"
          },
          {
            "name": "legalAddress.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.city",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "legalAddress.state",
            "type": "string",
            "required": true,
            "desc": "Two-letter US state or territory code (e.g. NY, CA). Must be a recognized USPS abbreviation."
          },
          {
            "name": "legalAddress.postalCode",
            "type": "string",
            "required": true,
            "desc": "US ZIP code, 5 or 9 digits, with or without a hyphen before the last 4 (e.g. 10118, 10118-1234)."
          },
          {
            "name": "legalAddress.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.countryCode",
            "type": "enum",
            "options": [
              "US"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "owner.dateOfBirth",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "owner.phoneNumber",
            "type": "string",
            "required": false,
            "desc": "Optional. When supplied, must contain at least 9 digits."
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/entities",
          "resource": "entities",
          "action": "create",
          "args": [],
          "body": {
            "type": "business",
            "externalId": "partner-biz-1234",
            "name": "Acme Supplies",
            "legalName": "Acme Supplies LLC",
            "phoneNumber": "+12125551234",
            "businessType": "llc",
            "taxInfo": {
              "type": "ein",
              "identifier": "12-3456789"
            },
            "industry": {
              "naicsCode": "424410"
            },
            "contact": {
              "firstName": "Jane",
              "lastName": "Doe"
            },
            "website": "https://acmesupplies.com",
            "address": {
              "line1": "350 5th Ave",
              "city": "New York",
              "state": "NY",
              "postalCode": "10118"
            },
            "legalAddress": {
              "line1": "350 5th Ave",
              "city": "New York",
              "state": "NY",
              "postalCode": "10118"
            },
            "owner": {
              "firstName": "Jane",
              "lastName": "Doe",
              "email": "jane.doe@acmesupplies.com",
              "dateOfBirth": "1985-04-12",
              "phoneNumber": "+12125559876"
            }
          }
        },
        "response": {
          "id": "ent_7c9e6679-7425-40de-944b-e07fc1f90ae7",
          "type": "business",
          "externalId": "partner-biz-1234",
          "createdAt": "2026-07-08T15:00:00Z",
          "updatedAt": "2026-07-08T15:00:00Z",
          "name": "Acme Supplies",
          "legalName": "Acme Supplies LLC",
          "businessType": "llc",
          "taxInfo": {
            "type": "ein",
            "identifierLast4": "6789"
          },
          "phoneNumber": "+12125551234",
          "contact": {
            "firstName": "Jane",
            "lastName": "Doe"
          },
          "website": "https://acmesupplies.com",
          "address": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "legalAddress": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "industry": {
            "naicsCode": "424410"
          },
          "owner": {
            "firstName": "Jane",
            "lastName": "Doe",
            "email": "jane.doe@acmesupplies.com"
          }
        },
        "responseFields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "business"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "id",
            "type": "string",
            "required": true,
            "desc": "Opaque entity id (ent_<uuid>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "businessType",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.type",
            "type": "enum",
            "options": [
              "ein",
              "ssn",
              "itin"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.identifierLast4",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "errorResponse": {
          "error": {
            "type": "conflict_error",
            "code": "DUPLICATE_ENTITY",
            "message": "Entity already exists; only platform partners may create additional entities"
          }
        }
      },
      {
        "id": "get-entities-entityid",
        "method": "GET",
        "path": "/v2/entities/{entityId}",
        "name": "Get an entity",
        "auth": "Partner key",
        "summary": "Get an entity",
        "params": [
          {
            "name": "entityId",
            "type": "string",
            "required": true,
            "desc": "An entity id (ent_<uuid>) or the sentinel `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/entities/ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d",
          "resource": "entities",
          "action": "retrieve",
          "args": [
            "ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d"
          ]
        },
        "response": {
          "id": "ent_7c9e6679-7425-40de-944b-e07fc1f90ae7",
          "type": "business",
          "externalId": "partner-biz-1234",
          "createdAt": "2026-07-08T15:00:00Z",
          "updatedAt": "2026-07-08T15:00:00Z",
          "name": "Acme Supplies",
          "legalName": "Acme Supplies LLC",
          "businessType": "llc",
          "taxInfo": {
            "type": "ein",
            "identifierLast4": "6789"
          },
          "phoneNumber": "+12125551234",
          "contact": {
            "firstName": "Jane",
            "lastName": "Doe"
          },
          "website": "https://acmesupplies.com",
          "address": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "legalAddress": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "industry": {
            "naicsCode": "424410"
          },
          "owner": {
            "firstName": "Jane",
            "lastName": "Doe",
            "email": "jane.doe@acmesupplies.com"
          }
        },
        "responseFields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "business"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "id",
            "type": "string",
            "required": true,
            "desc": "Opaque entity id (ent_<uuid>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "businessType",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.type",
            "type": "enum",
            "options": [
              "ein",
              "ssn",
              "itin"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.identifierLast4",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "patch-entities-entityid",
        "method": "PATCH",
        "path": "/v2/entities/{entityId}",
        "name": "Update an entity",
        "auth": "Partner key",
        "summary": "Updates an entity. Only the fields you send are changed. Some compliance fields (`legalName`, `legalAddress`, `taxInfo`) are fixed once the entity is created.\n",
        "params": [
          {
            "name": "entityId",
            "type": "string",
            "required": true,
            "desc": "An entity id (ent_<uuid>) or the sentinel `me` (the partner's sole entity)."
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed MelioSonar session token from the initiating device, used for risk evaluation; invalid or expired tokens return 403.\n"
          }
        ],
        "fields": [
          {
            "name": "name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "businessType",
            "type": "enum",
            "options": [
              "partnership",
              "sole-proprietorship",
              "llc",
              "corporation",
              "trust",
              "non-profit",
              "municipality"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": true,
            "desc": "Street address. Must not be a PO box for the business (physical) address.\n"
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": true,
            "desc": "Two-letter US state or territory code (e.g. NY, CA). Must be a recognized USPS abbreviation."
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": true,
            "desc": "US ZIP code, 5 or 9 digits, with or without a hyphen before the last 4 (e.g. 10118, 10118-1234)."
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "enum",
            "options": [
              "US"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.dateOfBirth",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "spec": {
          "method": "PATCH",
          "path": "/v2/entities/ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d",
          "resource": "entities",
          "action": "update",
          "args": [
            "ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d"
          ],
          "body": {
            "name": "Acme Supplies Co",
            "website": "https://acme-supplies.example.com",
            "metadata": {
              "crmId": "C-1"
            }
          }
        },
        "response": {
          "id": "ent_7c9e6679-7425-40de-944b-e07fc1f90ae7",
          "type": "business",
          "externalId": "partner-biz-1234",
          "metadata": {
            "crmId": "C-1"
          },
          "createdAt": "2026-07-08T15:00:00Z",
          "updatedAt": "2026-07-08T15:10:00Z",
          "name": "Acme Supplies Co",
          "legalName": "Acme Supplies LLC",
          "businessType": "llc",
          "taxInfo": {
            "type": "ein",
            "identifierLast4": "6789"
          },
          "phoneNumber": "+12125551234",
          "contact": {
            "firstName": "Jane",
            "lastName": "Doe"
          },
          "website": "https://acme-supplies.example.com",
          "address": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "legalAddress": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "industry": {
            "naicsCode": "424410"
          },
          "owner": {
            "firstName": "Jane",
            "lastName": "Doe",
            "email": "jane.doe@acmesupplies.com"
          }
        },
        "responseFields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "business"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "id",
            "type": "string",
            "required": true,
            "desc": "Opaque entity id (ent_<uuid>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "businessType",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.type",
            "type": "enum",
            "options": [
              "ein",
              "ssn",
              "itin"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.identifierLast4",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "get-entities-entityid-beneficial-owners",
        "method": "GET",
        "path": "/v2/entities/{entityId}/beneficial-owners",
        "name": "List beneficial owners",
        "auth": "Partner key",
        "summary": "The people recorded against the business for compliance: its ultimate beneficial owners, its directors, and the individual who acts for it towards the currency provider.\n\nThis is distinct from the entity's `owner`, which is the person the Melio account belongs to. The two are usually the same human, but `owner` carries no address, tax identifier or ownership stake, so it cannot satisfy international onboarding on its own.\n",
        "params": [
          {
            "name": "entityId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/entities/ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d/beneficial-owners",
          "resource": "entitiesBeneficialOwners",
          "action": "list",
          "args": [
            "ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d"
          ]
        },
        "response": {
          "data": [
            {
              "id": 0,
              "firstName": "string",
              "lastName": "string",
              "dateOfBirth": "2026-07-08",
              "address": {
                "line1": "string",
                "line2": "string",
                "city": "string",
                "state": "string",
                "postalCode": "string",
                "countryCode": "string"
              },
              "usResident": false,
              "ownershipPercentage": 0,
              "jobTitle": "chief-executive-officer",
              "taxInfo": {
                "type": "ssn",
                "identifierLast4": "string"
              },
              "internationalIdType": "passport",
              "internationalId": "string",
              "hasIdentityDocument": false,
              "types": [
                "ubo"
              ],
              "email": "string",
              "phoneNumber": "string",
              "createdAt": "2026-07-08T15:04:05Z",
              "updatedAt": "2026-07-08T15:04:05Z"
            }
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": true,
            "desc": ""
          }
        ]
      },
      {
        "id": "put-entities-entityid-beneficial-owners",
        "method": "PUT",
        "path": "/v2/entities/{entityId}/beneficial-owners",
        "name": "Replace beneficial owners",
        "auth": "Partner key",
        "summary": "Replaces the business's entire set of beneficial owners. Entries carrying an `id` are updated, entries without one are created, and **any person the payload omits is deleted**.\n\nReplace rather than patch because ownership percentages are only meaningful as a set: the currency provider validates their total, so a partial update has no coherent meaning. Read the current set first, modify it, and send it back whole.\n\nRecording an `fx-account-holder` is what unblocks `international-fx` accounts. Check `GET /limitations` afterwards to confirm nothing else is outstanding.\n",
        "params": [
          {
            "name": "entityId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "fields": [
          {
            "name": "data",
            "type": "object[]",
            "required": true,
            "desc": ""
          }
        ],
        "spec": {
          "method": "PUT",
          "path": "/v2/entities/ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d/beneficial-owners",
          "resource": "entitiesBeneficialOwners",
          "action": "list",
          "args": [
            "ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d"
          ],
          "body": {
            "data": [
              {
                "firstName": "Dana",
                "lastName": "Okonjo",
                "dateOfBirth": "1984-03-11",
                "address": {
                  "line1": "500 Congress Ave",
                  "city": "Austin",
                  "state": "TX",
                  "postalCode": "78701",
                  "countryCode": "US"
                },
                "usResident": true,
                "ownershipPercentage": 0.6,
                "jobTitle": "chief-executive-officer",
                "taxInfo": {
                  "type": "ssn",
                  "identifier": "123-45-6789"
                },
                "types": [
                  "ubo",
                  "director",
                  "fx-account-holder"
                ],
                "email": "dana@example.com"
              }
            ]
          }
        },
        "response": {
          "data": [
            {
              "id": 0,
              "firstName": "string",
              "lastName": "string",
              "dateOfBirth": "2026-07-08",
              "address": {
                "line1": "string",
                "line2": "string",
                "city": "string",
                "state": "string",
                "postalCode": "string",
                "countryCode": "string"
              },
              "usResident": false,
              "ownershipPercentage": 0,
              "jobTitle": "chief-executive-officer",
              "taxInfo": {
                "type": "ssn",
                "identifierLast4": "string"
              },
              "internationalIdType": "passport",
              "internationalId": "string",
              "hasIdentityDocument": false,
              "types": [
                "ubo"
              ],
              "email": "string",
              "phoneNumber": "string",
              "createdAt": "2026-07-08T15:04:05Z",
              "updatedAt": "2026-07-08T15:04:05Z"
            }
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": true,
            "desc": ""
          }
        ]
      },
      {
        "id": "get-limitations",
        "method": "GET",
        "path": "/v2/limitations",
        "name": "Get limitations",
        "auth": "Partner key",
        "summary": "Returns the entity's per-operation capabilities. Each operation (named `resource.subtype:action`) is either allowed or, if not, lists the reasons why (for example, missing information). Only write operations can be limited; read operations are always allowed and are not listed.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/limitations",
          "resource": "limitations",
          "action": "list",
          "args": []
        },
        "response": {
          "capabilities": [
            {
              "operation": "payment.domestic:write",
              "allowed": false,
              "reasons": [
                {
                  "code": "MissingInformation",
                  "message": "Additional information is required before this business can send payments.",
                  "missingFields": [
                    "taxInfo"
                  ]
                }
              ]
            },
            {
              "operation": "account.internal:write",
              "allowed": true,
              "reasons": []
            },
            {
              "operation": "account.external:write",
              "allowed": true,
              "reasons": []
            }
          ]
        },
        "responseFields": [
          {
            "name": "capabilities",
            "type": "object[]",
            "required": true,
            "desc": ""
          }
        ]
      }
    ]
  },
  {
    "id": "accounts",
    "label": "Accounts",
    "kind": "resource",
    "endpoints": [
      {
        "id": "get-accounts",
        "method": "GET",
        "path": "/v2/accounts",
        "name": "List accounts",
        "auth": "Partner key",
        "summary": "Returns the entity's accounts. Any internal Plaid account that isn't yet verified has its verification status refreshed from Plaid before the response is returned.\n",
        "queryParams": [
          {
            "name": "ownershipType",
            "type": "enum",
            "options": [
              "internal",
              "external"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "type",
            "type": "enum",
            "options": [
              "ach",
              "check",
              "card",
              "domestic-wire",
              "virtual-card"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Return only the account whose `externalId` matches (your own id)."
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Filter by metadata key/value pairs, e.g. `metadata[ledgerId]=L-9`. Matches accounts whose metadata contains every supplied pair.\n"
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/accounts",
          "resource": "accounts",
          "action": "list",
          "args": []
        },
        "response": {
          "data": [
            {
              "id": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
              "ownershipType": "external",
              "type": "ach",
              "counterPartyName": "Globex Manufacturing",
              "counterPartyEmail": "ap@globex.example.com",
              "bankAccount": {
                "accountType": "checking",
                "routingNumber": "111000025",
                "accountNumberLast4": "4321"
              },
              "createdAt": "2026-07-08T15:05:00Z",
              "updatedAt": "2026-07-08T15:05:00Z"
            },
            {
              "id": "acct_8be01c32-9378-4aad-9f0d-229e4454259c",
              "ownershipType": "external",
              "type": "check",
              "counterPartyName": "Initech",
              "counterPartyEmail": "ap@initech.example.com",
              "paperCheck": {
                "printName": "Initech",
                "address": {
                  "line1": "500 Market St",
                  "city": "San Francisco",
                  "state": "CA",
                  "postalCode": "94105"
                }
              },
              "createdAt": "2026-07-08T15:05:15Z",
              "updatedAt": "2026-07-08T15:05:15Z"
            }
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "post-accounts",
        "method": "POST",
        "path": "/v2/accounts",
        "name": "Create an account",
        "auth": "Partner key or session token",
        "summary": "Creates an account for the entity. An internal account is one the entity pays from (a bank account added through Plaid or, for selected partners, by its account and routing numbers). An external account is a payee the entity pays to, reachable by ACH, paper check, domestic wire, or virtual card. Authenticate with your api-key, or with a scoped session token from `POST /accounts/link` (which can only create internal accounts).\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          },
          {
            "name": "Idempotency-Key",
            "type": "string",
            "required": false,
            "desc": "Unique key (UUID recommended) that makes a create request safe to retry by replaying the original response; retained 24h per partner.\n"
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed MelioSonar session token from the initiating device, used for risk evaluation; invalid or expired tokens return 403.\n"
          }
        ],
        "fields": [
          {
            "name": "ownershipType",
            "type": "enum",
            "options": [
              "internal",
              "external"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "type",
            "type": "enum",
            "options": [
              "ach",
              "check",
              "domestic-wire",
              "virtual-card",
              "international-gusd"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "nickname",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "bankAccount.accountNumber",
            "type": "string",
            "required": true,
            "desc": "Required when ownershipType=internal, type=ach."
          },
          {
            "name": "bankAccount.routingNumber",
            "type": "string",
            "required": true,
            "desc": "Required when ownershipType=internal, type=ach."
          },
          {
            "name": "counterPartyName",
            "type": "string",
            "required": false,
            "desc": "Counterparty name Required when ownershipType=external, type=ach."
          },
          {
            "name": "counterPartyEmail",
            "type": "string",
            "required": false,
            "desc": "Counterparty (payee) email Required when ownershipType=external, type=ach."
          },
          {
            "name": "paperCheck.address",
            "type": "object",
            "required": true,
            "desc": "Required when ownershipType=external, type=check."
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": true,
            "desc": "Street address. Must not be a PO box for the business (physical) address.\n Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.city",
            "type": "string",
            "required": true,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.state",
            "type": "string",
            "required": true,
            "desc": "Two-letter US state or territory code (e.g. NY, CA). Must be a recognized USPS abbreviation. Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": true,
            "desc": "US ZIP code, 5 or 9 digits, with or without a hyphen before the last 4 (e.g. 10118, 10118-1234). Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.countryCode",
            "type": "enum",
            "options": [
              "US"
            ],
            "required": false,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "walletAddress",
            "type": "string",
            "required": false,
            "desc": "The counterparty's wallet address, between 32 and 44 characters. Required when ownershipType=external, type=international-gusd."
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/accounts",
          "resource": "accounts",
          "action": "create",
          "args": [],
          "body": {
            "ownershipType": "internal",
            "type": "ach",
            "nickname": "Operating account",
            "bankAccount": {
              "accountType": "checking",
              "accountNumber": "000123456789",
              "routingNumber": "021000021"
            }
          }
        },
        "response": {
          "id": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "ownershipType": "internal",
          "type": "ach",
          "nickname": "Operating account",
          "isVerified": true,
          "bankAccount": {
            "accountType": "checking",
            "routingNumber": "021000021",
            "accountNumberLast4": "6789"
          },
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:04:05Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque account id (acct_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "ownershipType",
            "type": "enum",
            "options": [
              "internal",
              "external"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "type",
            "type": "enum",
            "options": [
              "ach",
              "check",
              "card",
              "domestic-wire",
              "virtual-card",
              "international-fx",
              "international-gusd"
            ],
            "required": false,
            "desc": "Plaid-backed internal accounts are returned as ach."
          },
          {
            "name": "nickname",
            "type": "string",
            "required": false,
            "desc": "Present for internal accounts."
          },
          {
            "name": "counterPartyEmail",
            "type": "string",
            "required": false,
            "desc": "Counterparty (payee) email. Present for external accounts."
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "errorResponse": {
          "error": {
            "type": "conflict_error",
            "code": "DUPLICATE_EXTERNAL_ID",
            "message": "An account with externalId 'partner-acct-42' already exists."
          }
        }
      },
      {
        "id": "post-accounts-link",
        "method": "POST",
        "path": "/v2/accounts/link",
        "name": "Create a link to add a Plaid or card account",
        "auth": "Partner key",
        "summary": "Returns a short-lived link you hand to the entity. Opening it takes them to a Melio-hosted page that runs the Plaid or card flow and adds the internal account for them, so bank and card details never pass through your servers. Authenticate with your api-key.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed MelioSonar session token from the initiating device, used for risk evaluation; invalid or expired tokens return 403.\n"
          }
        ],
        "fields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "plaid",
              "card"
            ],
            "required": true,
            "desc": ""
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/accounts/link",
          "resource": "accountsLink",
          "action": "create",
          "args": [],
          "body": {
            "type": "plaid"
          }
        },
        "response": {
          "data": {
            "url": "https://portal.melio.com/payouts/link?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
            "expiration": "2026-07-08T16:04:05Z"
          }
        },
        "responseFields": [
          {
            "name": "data.url",
            "type": "string",
            "required": false,
            "desc": "Portal URL the entity opens to add the account (the scoped session JWT is embedded as ?token=)"
          },
          {
            "name": "data.expiration",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "get-accounts-accountid",
        "method": "GET",
        "path": "/v2/accounts/{accountId}",
        "name": "Get an account",
        "auth": "Partner key",
        "summary": "Returns a single account. If it's an internal Plaid account that isn't yet verified, its verification status is refreshed from Plaid before the response is returned.\n",
        "params": [
          {
            "name": "accountId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/accounts/acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "resource": "accounts",
          "action": "retrieve",
          "args": [
            "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301"
          ]
        },
        "response": {
          "id": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "ownershipType": "internal",
          "type": "ach",
          "nickname": "Operating account",
          "isVerified": false,
          "bankAccount": {
            "accountType": "checking",
            "routingNumber": "021000021",
            "accountNumberLast4": "6789"
          },
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:04:05Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque account id (acct_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "ownershipType",
            "type": "enum",
            "options": [
              "internal",
              "external"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "type",
            "type": "enum",
            "options": [
              "ach",
              "check",
              "card",
              "domestic-wire",
              "virtual-card",
              "international-fx",
              "international-gusd"
            ],
            "required": false,
            "desc": "Plaid-backed internal accounts are returned as ach."
          },
          {
            "name": "nickname",
            "type": "string",
            "required": false,
            "desc": "Present for internal accounts."
          },
          {
            "name": "counterPartyEmail",
            "type": "string",
            "required": false,
            "desc": "Counterparty (payee) email. Present for external accounts."
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "delete-accounts-accountid",
        "method": "DELETE",
        "path": "/v2/accounts/{accountId}",
        "name": "Delete an account",
        "auth": "Partner key",
        "summary": "Deletes an account. An account referenced by any payment can't be deleted.",
        "params": [
          {
            "name": "accountId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "DELETE",
          "path": "/v2/accounts/acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "resource": "accounts",
          "action": "delete",
          "args": [
            "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301"
          ]
        },
        "response": {},
        "errorResponse": {
          "error": {
            "type": "conflict_error",
            "code": "ACCOUNT_IN_USE",
            "message": "Account cannot be deleted because it is referenced by one or more payments"
          }
        }
      },
      {
        "id": "post-accounts-accountid-verify-link",
        "method": "POST",
        "path": "/v2/accounts/{accountId}/verify/link",
        "name": "Create a link to verify a Plaid account",
        "auth": "Partner key",
        "summary": "For an unverified internal Plaid account, returns a short-lived link you hand to the entity. Opening it takes them to a Melio-hosted page where they complete same-day micro-deposit verification in Plaid. Authenticate with your api-key.\n",
        "params": [
          {
            "name": "accountId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed MelioSonar session token from the initiating device, used for risk evaluation; invalid or expired tokens return 403.\n"
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/accounts/acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301/verify/link",
          "resource": "accountsVerifyLink",
          "action": "create",
          "args": [
            "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301"
          ]
        },
        "response": {
          "data": {
            "url": "https://portal.melio.com/accounts/verify?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9&type=plaid",
            "expiration": "2026-07-08T16:04:05Z"
          }
        },
        "responseFields": [
          {
            "name": "data.url",
            "type": "string",
            "required": false,
            "desc": "Portal URL the entity opens to add the account (the scoped session JWT is embedded as ?token=)"
          },
          {
            "name": "data.expiration",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      }
    ]
  },
  {
    "id": "payments",
    "label": "Payments",
    "kind": "resource",
    "endpoints": [
      {
        "id": "get-payments",
        "method": "GET",
        "path": "/v2/payments",
        "name": "List payments",
        "auth": "Partner key",
        "summary": "Returns the entity's payments, newest first. Use the filters below to narrow the list; they can be combined with each other and with pagination.\n",
        "queryParams": [
          {
            "name": "limit",
            "type": "integer",
            "required": false,
            "desc": "Maximum number of resources to return, 1 to 50. Defaults to 50."
          },
          {
            "name": "startingAfter",
            "type": "string",
            "required": false,
            "desc": "Cursor for forward (older) pagination: a resource id. The page returned starts immediately after this resource. Mutually exclusive with `endingBefore`.\n"
          },
          {
            "name": "endingBefore",
            "type": "string",
            "required": false,
            "desc": "Cursor for backward (newer) pagination: a resource id. The page returned ends immediately before this resource. Mutually exclusive with `startingAfter`.\n"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Return only the payment whose `externalId` matches (your own id)."
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "Filter by payment status."
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Return only payments drawn from this internal originating account (acct_<id>)."
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "Return only payments sent to this external receiving account (acct_<id>)."
          },
          {
            "name": "created[gte]",
            "type": "string",
            "required": false,
            "desc": "Return payments created at or after this RFC 3339 timestamp."
          },
          {
            "name": "created[lte]",
            "type": "string",
            "required": false,
            "desc": "Return payments created at or before this RFC 3339 timestamp."
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Filter by metadata key/value pairs, e.g. `metadata[invoiceId]=INV-42`. Matches payments whose metadata contains every supplied pair.\n"
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/payments",
          "resource": "payments",
          "action": "list",
          "args": []
        },
        "response": {
          "hasMore": true,
          "data": [
            {
              "id": "pay_9f8c7b6a5d4e3f21",
              "externalId": "invoice-2043",
              "amount": 125000,
              "currency": "USD",
              "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
              "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
              "deductionDate": "2026-07-10",
              "deliveryPreference": "standard-ach",
              "deliveryDate": "2026-07-14",
              "status": "scheduled",
              "metadata": {
                "invoiceId": "INV-2043",
                "department": "operations"
              },
              "fees": [],
              "createdAt": "2026-07-08T15:04:05Z",
              "updatedAt": "2026-07-08T15:04:05Z"
            },
            {
              "id": "pay_1a2b3c4d5e6f7a8b",
              "externalId": "invoice-2041",
              "amount": 4200,
              "currency": "USD",
              "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
              "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
              "deductionDate": "2026-07-09",
              "deliveryPreference": "same-day-ach",
              "deliveryDate": "2026-07-11",
              "status": "completed",
              "metadata": {},
              "fees": [
                {
                  "type": "same-day-ach",
                  "chargeTo": "originator",
                  "percent": {
                    "rate": 0.5,
                    "max": 3000
                  },
                  "amount": 21,
                  "status": "charged"
                }
              ],
              "createdAt": "2026-07-07T09:22:00Z",
              "updatedAt": "2026-07-07T09:22:00Z"
            }
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": true,
            "desc": ""
          },
          {
            "name": "hasMore",
            "type": "boolean",
            "required": true,
            "desc": "True when more resources exist after this page; page again using the last item's id as `startingAfter`."
          }
        ]
      },
      {
        "id": "post-payments",
        "method": "POST",
        "path": "/v2/payments",
        "name": "Create a payment",
        "auth": "Partner key",
        "summary": "Creates a payment from one of the entity's internal accounts to one of its external accounts. An `Idempotency-Key` header is required so the request is safe to retry.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          },
          {
            "name": "Idempotency-Key",
            "type": "string",
            "required": true,
            "desc": "Required unique key (UUID recommended) that makes payment creation safe to retry by replaying the original response; retained 24h per partner, omitting it returns 400.\n"
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed MelioSonar session token from the initiating device, used for risk evaluation; invalid or expired tokens return 403.\n"
          }
        ],
        "fields": [
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "Minor units of the currency the counterparty is paid in — the amount they receive. For a converted payment (`CreateFxPaymentRequest`) that is the foreign amount, and the entity is debited the equivalent in USD at the applied rate.\n"
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": "Internal originating account id (acct_<id>), the debit account"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": "External receiving account id (acct_<id>), the credit account"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": "The currency the counterparty is paid in, which must match the receiving account's. `USD` for every domestic rail and for `international-gusd`, where it is the default and safe to omit; on `CreateFxPaymentRequest` it is required and must be the account's own `currency`. A mismatch — including `USD` against an `international-fx` account, which is never dollar-denominated — is rejected with `400 VALIDATION_ERROR`.\n"
          },
          {
            "name": "attachmentId",
            "type": "string",
            "required": false,
            "desc": "A supporting document for this payment, from `POST /attachments` (`att_<id>`).\n\nSome international destinations will not accept a payment without one — the provider decides which, based on the destination country's risk rating, and the requirement can also depend on whether you have paid that counterparty before. When it applies and no `attachmentId` is given, the payment is rejected with `400 ATTACHMENT_REQUIRED`; upload the document and retry. Sending one where it is not required is always accepted.\n\nThe document is attached at creation, so it cannot be added or replaced with `PATCH /payments/{paymentId}`. The attachment must belong to the same entity as the payment, otherwise the request is rejected with `404`.\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card",
              "international-gusd"
            ],
            "required": true,
            "desc": "Required, and explicit about the receiving rail and delivery speed.\n\nThe preference's rail must match the receiving external account, otherwise the\nrequest is rejected with `400`.\n\nWith a bank (ACH) originating account, funds are collected before they are\ndelivered (the good-funds model): the standard values deliver at the rail's normal\nspeed, and the faster variants are subject to a per-payment eligibility check — an\nineligible fast variant is rejected with `400` (never silently downgraded).\n\nWith a card originating account, the collect is immediate, so ACH and wire payments\nalready deliver at the fast speed: use `same-day-ach` (not `standard-ach`) and\n`instant-domestic-wire` (not `domestic-wire`) — the superseded standard values are\nrejected with `400`, and no eligibility check applies to these two. Check values\nare unchanged, and virtual-card receiving accounts cannot be paid from a card\noriginating account.\n"
          },
          {
            "name": "compliance",
            "type": "object",
            "required": true,
            "desc": "Compliance details, discriminated by `type`. Only `goods-and-services` is supported today; future payment types (internal money movement, mass payouts) will add their own variants with different fields.\n"
          },
          {
            "name": "fxQuoteToken",
            "type": "string",
            "required": false,
            "desc": "The `quoteToken` returned by `POST /tools/fx-quote`, which locks the rate the payment is executed at. Optional: when omitted, the rate prevailing at creation is applied.\n\nA converted payment takes both its amounts from the quote, so the token must have been issued for this payment: one that is expired, or issued for a different `currency` or a different `amount`, is rejected with `400 FX_QUOTE_INVALID` rather than silently replacing what you asked to send.\n"
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/payments",
          "resource": "payments",
          "action": "create",
          "args": [],
          "body": {
            "amount": 125000,
            "currency": "USD",
            "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
            "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            "deductionDate": "2026-07-10",
            "deliveryPreference": "standard-ach",
            "compliance": {
              "type": "goods-and-services"
            },
            "externalId": "invoice-2043",
            "noteToRecipient": "July materials order",
            "metadata": {
              "invoiceId": "INV-2043",
              "department": "operations"
            }
          }
        },
        "response": {
          "id": "pay_9f8c7b6a5d4e3f21",
          "externalId": "invoice-2043",
          "amount": 125000,
          "currency": "USD",
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "deductionDate": "2026-07-10",
          "deliveryPreference": "standard-ach",
          "deliveryDate": "2026-07-14",
          "status": "scheduled",
          "noteToRecipient": "July materials order",
          "metadata": {
            "invoiceId": "INV-2043",
            "department": "operations"
          },
          "fees": [],
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:04:05Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque payment id (pay_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": ""
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Internal originating account id (acct_<id>)"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "External receiving account id (acct_<id>)"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card",
              "international-fx",
              "fast-international-fx",
              "international-gusd"
            ],
            "required": true,
            "desc": "Effective delivery preference. Reflects the faster variant when one was applied, otherwise the receiving rail's normal-speed value. Card-funded ACH and wire payments always report the fast name (`same-day-ach` / `instant-domestic-wire`) — a card collect is immediate, so those payments deliver at the fast speed.\n"
          },
          {
            "name": "deliveryDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "While a payment is being reviewed it is reported as `scheduled`; there is no separate review status.\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "fees",
            "type": "object[]",
            "required": true,
            "desc": "The fees charged for this payment, as recorded by the fees service. Includes both the originator-side and receiver-side fees; use `chargeTo` on each item to tell them apart. Always present — an empty array when no fees have been recorded yet (e.g. a freshly created payment).\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "errorResponse": {
          "error": {
            "type": "conflict_error",
            "code": "DUPLICATE_EXTERNAL_ID",
            "message": "A payment with externalId 'invoice-2043' already exists."
          }
        }
      },
      {
        "id": "get-payments-paymentid",
        "method": "GET",
        "path": "/v2/payments/{paymentId}",
        "name": "Get a payment",
        "auth": "Partner key",
        "summary": "Returns a single payment by its Melio id (`pay_<id>`). To look one up by your own identifier instead, list payments with `?externalId=`.\n",
        "params": [
          {
            "name": "paymentId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/payments/pay_9f8c7b6a5d4e3f21",
          "resource": "payments",
          "action": "retrieve",
          "args": [
            "pay_9f8c7b6a5d4e3f21"
          ]
        },
        "response": {
          "id": "pay_9f8c7b6a5d4e3f21",
          "externalId": "invoice-2043",
          "amount": 125000,
          "currency": "USD",
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "deductionDate": "2026-07-10",
          "deliveryPreference": "standard-ach",
          "deliveryDate": "2026-07-14",
          "status": "scheduled",
          "metadata": {
            "invoiceId": "INV-2043",
            "department": "operations"
          },
          "fees": [
            {
              "type": "standard-ach",
              "chargeTo": "originator",
              "fixed": {
                "value": 50
              },
              "amount": 50,
              "status": "charged"
            }
          ],
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:04:05Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque payment id (pay_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": ""
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Internal originating account id (acct_<id>)"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "External receiving account id (acct_<id>)"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card",
              "international-fx",
              "fast-international-fx",
              "international-gusd"
            ],
            "required": true,
            "desc": "Effective delivery preference. Reflects the faster variant when one was applied, otherwise the receiving rail's normal-speed value. Card-funded ACH and wire payments always report the fast name (`same-day-ach` / `instant-domestic-wire`) — a card collect is immediate, so those payments deliver at the fast speed.\n"
          },
          {
            "name": "deliveryDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "While a payment is being reviewed it is reported as `scheduled`; there is no separate review status.\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "fees",
            "type": "object[]",
            "required": true,
            "desc": "The fees charged for this payment, as recorded by the fees service. Includes both the originator-side and receiver-side fees; use `chargeTo` on each item to tell them apart. Always present — an empty array when no fees have been recorded yet (e.g. a freshly created payment).\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "patch-payments-paymentid",
        "method": "PATCH",
        "path": "/v2/payments/{paymentId}",
        "name": "Update a payment",
        "auth": "Partner key",
        "summary": "Updates a payment while its `status` is still `scheduled`. Once processing has begun, the request returns `409 PAYMENT_NOT_EDITABLE`. Only the fields you send are changed.\n",
        "params": [
          {
            "name": "paymentId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed MelioSonar session token from the initiating device, used for risk evaluation; invalid or expired tokens return 403.\n"
          }
        ],
        "fields": [
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": "Minor units (cents). Amount changes may be rejected (400) when the partner is not configured to allow them or when the payment spans multiple bills.\n"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": "The debit/schedule date"
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card",
              "international-fx",
              "fast-international-fx",
              "international-gusd"
            ],
            "required": false,
            "desc": "See CreatePaymentRequest.deliveryPreference. The preference's rail must match the payment's receiving account, and only the values allowed for the payment's originating account are accepted (card-funded ACH/wire payments use `same-day-ach` / `instant-domestic-wire`); fast variants remain subject to the per-payment eligibility check and are rejected with 400 when ineligible."
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          }
        ],
        "spec": {
          "method": "PATCH",
          "path": "/v2/payments/pay_9f8c7b6a5d4e3f21",
          "resource": "payments",
          "action": "update",
          "args": [
            "pay_9f8c7b6a5d4e3f21"
          ],
          "body": {
            "deliveryPreference": "rtp",
            "noteToRecipient": "Invoice 42 (updated)",
            "metadata": {
              "invoiceId": "INV-2043"
            }
          }
        },
        "response": {
          "id": "pay_9f8c7b6a5d4e3f21",
          "externalId": "invoice-2043",
          "amount": 125000,
          "currency": "USD",
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "deductionDate": "2026-07-10",
          "deliveryPreference": "rtp",
          "deliveryDate": "2026-07-10",
          "status": "scheduled",
          "noteToRecipient": "Invoice 42 (updated)",
          "metadata": {
            "invoiceId": "INV-2043"
          },
          "fees": [],
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:12:00Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque payment id (pay_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": ""
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Internal originating account id (acct_<id>)"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "External receiving account id (acct_<id>)"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card",
              "international-fx",
              "fast-international-fx",
              "international-gusd"
            ],
            "required": true,
            "desc": "Effective delivery preference. Reflects the faster variant when one was applied, otherwise the receiving rail's normal-speed value. Card-funded ACH and wire payments always report the fast name (`same-day-ach` / `instant-domestic-wire`) — a card collect is immediate, so those payments deliver at the fast speed.\n"
          },
          {
            "name": "deliveryDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "While a payment is being reviewed it is reported as `scheduled`; there is no separate review status.\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "fees",
            "type": "object[]",
            "required": true,
            "desc": "The fees charged for this payment, as recorded by the fees service. Includes both the originator-side and receiver-side fees; use `chargeTo` on each item to tell them apart. Always present — an empty array when no fees have been recorded yet (e.g. a freshly created payment).\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "post-payments-paymentid-cancel",
        "method": "POST",
        "path": "/v2/payments/{paymentId}/cancel",
        "name": "Cancel a payment",
        "auth": "Partner key",
        "summary": "Cancels a payment while its `status` is still `scheduled` — i.e. before it begins processing. The payment moves to `status: canceled`. Once processing has begun, the request returns `409 PAYMENT_NOT_CANCELABLE`.\n",
        "params": [
          {
            "name": "paymentId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/payments/pay_9f8c7b6a5d4e3f21/cancel",
          "resource": "paymentsCancel",
          "action": "create",
          "args": [
            "pay_9f8c7b6a5d4e3f21"
          ]
        },
        "response": {
          "id": "pay_9f8c7b6a5d4e3f21",
          "externalId": "invoice-2043",
          "amount": 125000,
          "currency": "USD",
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "deductionDate": "2026-07-10",
          "deliveryPreference": "standard-ach",
          "deliveryDate": "2026-07-14",
          "status": "canceled",
          "metadata": {
            "invoiceId": "INV-2043"
          },
          "fees": [],
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:20:00Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque payment id (pay_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": ""
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Internal originating account id (acct_<id>)"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "External receiving account id (acct_<id>)"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card",
              "international-fx",
              "fast-international-fx",
              "international-gusd"
            ],
            "required": true,
            "desc": "Effective delivery preference. Reflects the faster variant when one was applied, otherwise the receiving rail's normal-speed value. Card-funded ACH and wire payments always report the fast name (`same-day-ach` / `instant-domestic-wire`) — a card collect is immediate, so those payments deliver at the fast speed.\n"
          },
          {
            "name": "deliveryDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "While a payment is being reviewed it is reported as `scheduled`; there is no separate review status.\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1 to 40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "fees",
            "type": "object[]",
            "required": true,
            "desc": "The fees charged for this payment, as recorded by the fees service. Includes both the originator-side and receiver-side fees; use `chargeTo` on each item to tell them apart. Always present — an empty array when no fees have been recorded yet (e.g. a freshly created payment).\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "post-simulations-payments-paymentid-actions",
        "method": "POST",
        "path": "/v2/simulations/payments/{paymentId}/actions",
        "name": "Simulate a payment action",
        "auth": "Partner key",
        "badge": "Sandbox only",
        "summary": "Advances a payment through its lifecycle for testing: approve or decline the risk review, collect or deliver the funds, or simulate a collection or delivery failure. The action runs against the real payment, so the status change and any webhooks fire just as in production. Available in non-production environments only.\n",
        "params": [
          {
            "name": "paymentId",
            "type": "string",
            "required": true,
            "desc": "A payment id (pay_<id>)."
          }
        ],
        "headerParams": [
          {
            "name": "Idempotency-Key",
            "type": "string",
            "required": false,
            "desc": "Unique key (UUID recommended) that makes a create request safe to retry by replaying the original response; retained 24h per partner.\n"
          }
        ],
        "fields": [
          {
            "name": "action",
            "type": "enum",
            "options": [
              "risk-approve",
              "risk-decline",
              "collect",
              "deliver",
              "fail-collect",
              "fail-deliver"
            ],
            "required": true,
            "desc": "The payment lifecycle transition to simulate."
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Optional metadata echoed to logs; not persisted on the payment."
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/simulations/payments/pay_9f8c7b6a5d4e3f21/actions",
          "resource": "simulationsPaymentsActions",
          "action": "create",
          "args": [
            "pay_9f8c7b6a5d4e3f21"
          ],
          "body": {
            "action": "risk-approve"
          }
        },
        "response": {}
      }
    ]
  },
  {
    "id": "attachments",
    "label": "Attachments",
    "kind": "resource",
    "endpoints": [
      {
        "id": "post-attachments",
        "method": "POST",
        "path": "/v2/attachments",
        "name": "Upload an attachment",
        "auth": "Partner key",
        "summary": "Stores a supporting document for the entity and returns an opaque id you can pass as `attachmentId` when creating a payment. Upload once, reference from as many payments as you need.\n\nSend `multipart/form-data` with the document in a part named `file`. PDF, JPEG and PNG are accepted, up to 8 MB. The bytes are not readable back through this API — only the metadata below is returned.\n\nThe main reason to use this: some international destinations will not accept a payment without a supporting document, and `POST /payments` then fails with `400 ATTACHMENT_REQUIRED`. See `attachmentId` on the payment request.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/attachments",
          "resource": "attachments",
          "action": "create",
          "args": []
        },
        "response": {
          "id": "att_9f8b7c6d-5e4f-4a3b-8c2d-1e0f9a8b7c6d",
          "fileName": "invoice-2043.pdf",
          "mimeType": "application/pdf",
          "byteSize": 182734,
          "createdAt": "2026-09-07T10:15:00.000Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": true,
            "desc": "Attachment id (att_<id>). Pass as `attachmentId` on `POST /payments`."
          },
          {
            "name": "fileName",
            "type": "string",
            "required": true,
            "desc": "The filename as uploaded."
          },
          {
            "name": "mimeType",
            "type": "enum",
            "options": [
              "application/pdf",
              "image/jpeg",
              "image/png"
            ],
            "required": true,
            "desc": "The document's media type."
          },
          {
            "name": "byteSize",
            "type": "integer",
            "required": true,
            "desc": "Size of the uploaded document in bytes."
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": true,
            "desc": "When the document was stored."
          }
        ]
      }
    ]
  },
  {
    "id": "tools",
    "label": "Tools",
    "kind": "resource",
    "endpoints": [
      {
        "id": "post-tools-fee-calculator",
        "method": "POST",
        "path": "/v2/tools/fee-calculator",
        "name": "Calculate fees",
        "auth": "Partner key",
        "summary": "Estimates the fees for a payment between two of the entity's accounts, without creating one. Fees depend on the originating account, the receiving account, the `deliveryPreference`, and the `amount`. All amounts are in minor units (cents).\n\nFor a payment that converts currency this prices the fees only; use `POST /tools/fx-quote` for the exchange rate and the amount that would be debited.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "fields": [
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": "Internal originating account id (acct_<id>), the debit account"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": "External receiving account id (acct_<id>), the credit account"
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card",
              "international-fx",
              "fast-international-fx",
              "international-gusd"
            ],
            "required": true,
            "desc": "The delivery preference to price. Its rail must match the receiving account, and only the values allowed for the originating account are accepted (see CreatePaymentRequest.deliveryPreference — card-funded ACH/wire payments use `same-day-ach` / `instant-domestic-wire`). The normal-speed values (`standard-ach`, `standard-check`, `domestic-wire`, `virtual-card`) price that rail at normal speed."
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "The payment amount to price, in minor units of `currency` — for an international account, the amount the counterparty receives.\n"
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": "Must match the receiving account's currency, exactly as on `POST /payments`.\n"
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/tools/fee-calculator",
          "resource": "toolsFeeCalculator",
          "action": "create",
          "args": [],
          "body": {
            "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
            "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            "deliveryPreference": "same-day-ach",
            "amount": 125000
          }
        },
        "response": [
          {
            "type": "same-day-ach",
            "chargeTo": "originator",
            "percent": {
              "rate": 0.5,
              "max": 3000
            },
            "amount": 625
          }
        ],
        "responseFields": []
      },
      {
        "id": "post-tools-fx-quote",
        "method": "POST",
        "path": "/v2/tools/fx-quote",
        "name": "Quote a currency conversion",
        "auth": "Partner key",
        "summary": "Prices a conversion for a payment to an `international-fx` account denominated in a currency other than USD, and returns a short-lived `quoteToken` that locks the rate.\n\nPass the token as `fxQuoteToken` on `POST /payments` to be charged exactly what was quoted. The token is optional — omit it and the payment is priced again at creation time, at whatever rate then applies.\n\nFees are priced separately by `POST /tools/fee-calculator`; the two are independent and can be called in either order.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "fields": [
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": "External receiving account id (acct_<id>), the credit account"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "Minor units of `currency` — the amount the counterparty would receive.\n"
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": "Must match the receiving account's currency. Optional, but sending it turns a wrong assumption into a `400` instead of a quote in an unexpected currency.\n"
          },
          {
            "name": "purpose",
            "type": "string",
            "required": false,
            "desc": "Why the money is being sent. Passed to the currency provider when the quote is minted, so send the same value you will send as `compliance.purpose` on the payment.\n"
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/tools/fx-quote",
          "resource": "toolsFxQuote",
          "action": "create",
          "args": [],
          "body": {
            "receivingAccountId": "acct_2a4f9c31-77ad-4c1e-8b52-6d3f0a91c4e7",
            "amount": 100000,
            "currency": "EUR",
            "purpose": "payment for consulting services"
          }
        },
        "response": {
          "currency": "EUR",
          "foreignAmount": 100000,
          "amount": 110250,
          "usdToForeignRate": 0.907,
          "midMarketRate": 0.9125,
          "quoteToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmb3JlaWduQ3VycmVuY3kiOiJFVVIifQ.sig",
          "expiresAt": "2026-09-06T12:34:56Z"
        },
        "responseFields": [
          {
            "name": "currency",
            "type": "string",
            "required": true,
            "desc": "ISO 4217 code of the currency delivered"
          },
          {
            "name": "foreignAmount",
            "type": "integer",
            "required": true,
            "desc": "Minor units of `currency` delivered to the counterparty"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "Minor units of USD debited from the entity, before fees"
          },
          {
            "name": "usdToForeignRate",
            "type": "number",
            "required": true,
            "desc": "The applied rate: units of `currency` per USD"
          },
          {
            "name": "midMarketRate",
            "type": "number",
            "required": false,
            "desc": "The mid-market reference rate, for comparison"
          },
          {
            "name": "quoteToken",
            "type": "string",
            "required": true,
            "desc": "Opaque, short-lived token locking this rate. Pass it as `fxQuoteToken` on `POST /payments`, for a payment of this `amount` in this `currency` — the token is checked against both, so it cannot be spent on a payment it was not quoted for. Treat it as opaque; its format is not part of this contract.\n"
          },
          {
            "name": "expiresAt",
            "type": "string",
            "required": false,
            "desc": "When the token stops being accepted. After this, quote again."
          }
        ]
      },
      {
        "id": "post-tools-fast-payment-eligibility",
        "method": "POST",
        "path": "/v2/tools/fast-payment-eligibility",
        "name": "Check fast payment eligibility",
        "auth": "Partner key",
        "summary": "Checks which faster-than-standard delivery options a payment between two of the entity's accounts is eligible for, without creating one. Eligibility depends on the originating account, the receiving account, and the `amount` (minor units, cents). The response has one entry per fast option valid for the receiving account and the originating account's funding type, for example `same-day-ach` and `rtp` for ACH, or `express-check` and `overnight-check` for check. With a card originating account the collect is immediate, so `same-day-ach` and `instant-domestic-wire` are always eligible.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "fields": [
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": "Internal originating account id (acct_<id>), the debit account"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": "External receiving account id (acct_<id>), the credit account"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "The prospective payment amount to check, in minor units (cents)."
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/tools/fast-payment-eligibility",
          "resource": "toolsFastPaymentEligibility",
          "action": "create",
          "args": [],
          "body": {
            "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
            "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            "amount": 125000
          }
        },
        "response": {
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "amount": 125000,
          "currency": "USD",
          "eligibilities": [
            {
              "deliveryPreference": "same-day-ach",
              "eligible": true
            },
            {
              "deliveryPreference": "rtp",
              "eligible": false
            }
          ]
        },
        "responseFields": [
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "Echoes the requested payment amount, minor units (cents)."
          },
          {
            "name": "currency",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "eligibilities",
            "type": "object[]",
            "required": true,
            "desc": "One entry per fast delivery preference valid for the receiving external account and the originating account's funding type. Card-funded `same-day-ach` / `instant-domestic-wire` are always eligible — the collect is immediate, so no eligibility check applies. Empty when no fast variants are available for the combination (e.g. a card originating account with a virtual-card receiving account).\n"
          }
        ]
      },
      {
        "id": "post-tools-delivery-eta",
        "method": "POST",
        "path": "/v2/tools/delivery-eta",
        "name": "Estimate delivery dates",
        "auth": "Partner key",
        "summary": "Estimates when a payment between two of the entity's accounts would be delivered, without creating one. The response has one estimate per delivery option valid for the receiving account and the originating account's funding type, for example `standard-ach`, `same-day-ach`, and `rtp` for ACH with a bank originating account, or `same-day-ach` and `rtp` with a card. `deductionDate` is the debit date used for the estimate (defaults to today); `amount` is in minor units (cents).\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "Entity the request operates on — an entity id (`ent_<uuid>`) or `me` (the partner's sole entity)."
          }
        ],
        "fields": [
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": "Internal originating account id (acct_<id>), the debit account"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": "External receiving account id (acct_<id>), the credit account"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "The prospective payment amount to estimate for, in minor units (cents)."
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": "The debit/schedule date the estimate is based on. Defaults to the current date when omitted."
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/tools/delivery-eta",
          "resource": "toolsDeliveryEta",
          "action": "create",
          "args": [],
          "body": {
            "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
            "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            "amount": 125000,
            "deductionDate": "2026-07-10"
          }
        },
        "response": {
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "amount": 125000,
          "currency": "USD",
          "deductionDate": "2026-07-10",
          "estimates": [
            {
              "deliveryPreference": "standard-ach",
              "deliveryDate": "2026-07-14"
            },
            {
              "deliveryPreference": "same-day-ach",
              "deliveryDate": "2026-07-10"
            },
            {
              "deliveryPreference": "rtp",
              "deliveryDate": "2026-07-10"
            }
          ]
        },
        "responseFields": [
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "Echoes the requested payment amount, minor units (cents)."
          },
          {
            "name": "currency",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": true,
            "desc": "The debit/schedule date the estimates are based on."
          },
          {
            "name": "estimates",
            "type": "object[]",
            "required": true,
            "desc": "One entry per delivery preference valid for the receiving external account. Empty when the rail has no valid preferences.\n"
          }
        ]
      }
    ]
  }
];

// Spec-sourced metadata for the overview hero (version pills, server list, auth description).
// Any field the spec doesn't declare is simply absent — consumers must render nothing rather
// than fall back to invented copy.
export const API_META: {
  version?: string;
  oasVersion?: string;
  servers?: { url: string; description?: string }[];
  authDescription?: string;
} = {
  "version": "1.0",
  "oasVersion": "3.0.3",
  "servers": [
    {
      "description": "Production",
      "url": "https://api.melio.com/v2"
    },
    {
      "description": "Staging01",
      "url": "https://api.staging01.melio.com/v2"
    }
  ]
};
